import axios from "axios";

const http = axios.create();

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("usertoken");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

http.interceptors.response.use(
  (result) => {
    return result;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
      }
    } else {
      console.log("error occured");
    }
  }
);

const post = (url, data, params = {}) => {
  const header = {
    "Content-Type": "application/json",
  };

  return http.post(url, data, {
    params: params,
    headers: header,
    ...params,
  });
};

const multi_part_put = (url, data, params = {}) => {
  const header = {
    "Content-Type": "multipart/form-data",
  };

  return axios.put(url, data, { ...params, headers: header });
};

const multi_part_post = (url, data, params = {}) => {
  const header = {
    "Content-Type": "multipart/form-data",
    Authorization: "Bearer " + localStorage.getItem("usertoken"),
    withCredentials: true,
    crossdomain: true,
  };

  return axios.post(url, data, { ...params, params: params, headers: header });
};

const get = (url, queries, params = {}) => {
  const header = {};
  return http.get(url, {
    params: queries,
    ...params,
    headers: header,
  });
};

const put = (url, data, params = {}) => {
  const header = {};
  return http.put(url, data, {
    params: params,
    ...params,
    headers: header,
  });
};

const patch = (url, data, id, params = {}) => {
  const header = {};
  return http.patch(url + "/" + id, data, {
    ...params,
    headers: header,
  });
};

const remove = (url, data) => {
  const header = {};
  return http.delete(url, {
    headers: header,
    data,
  });
};

const HttpService = {
  http,
  get,
  post,
  multi_part_post,
  put,
  patch,
  multi_part_put,
  remove,
};

export default HttpService;
